import { render, staticRenderFns } from "./OnlineAccess.vue?vue&type=template&id=5bd43a50&"
import script from "./OnlineAccess.vue?vue&type=script&lang=js&"
export * from "./OnlineAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports